import './Landingpage.css';
import Topbar from '../../components/Topbar/Topbar';
import Footer from '../../components/footer/Footer';
import ContainerA from '../../components/ContainerA/ContainerA';
import Carousel from '../../components/Carousel/Carousel';

const Landingpage = () => {


  return (
    <div className='Landing-container'>
      <Topbar/>
      <ContainerA/>
      <Carousel/>
     <Footer/>
    </div>
  );
};

export default Landingpage;
